import React from 'react';
import PropTypes from 'prop-types';

import StringTypeField from "./types/StringTypeField";
import CheckboxTypeField from "./types/CheckboxTypeField";
import SwitchTypeField from "./types/SwitchTypeField";

FormikInput.propTypes = {
    type: PropTypes.oneOf([
        'string',
        'password',
        'number',
        'checkbox',
        'switch',
        'toggle'
    ]),
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    noPadding: PropTypes.bool
};

function FormikInput(
    {type = 'string', name, label, placeholder, required = false, disabled = false, noPadding = false, checked = false}
) {
    switch (type) {
        case 'string':
        case 'password':
            return (
                <StringTypeField
                    type={type}
                    name={name}
                    label={label}
                    placeholder={placeholder}
                    required={required}
                    disabled={disabled}
                />
            );
        case 'number':
            return null;
        case 'checkbox':
            return (
                <CheckboxTypeField
                    name={name}
                    label={label}
                    required={required}
                    disabled={disabled}
                    noPadding={noPadding}
                    checked={checked}
                />
            )
        case 'switch':
        case 'toggle':
            return (
                <SwitchTypeField
                    name={name}
                    label={label}
                    required={required}
                    disabled={disabled}
                    checked={checked}
                />
            )
        default:
            return null;
    }
}

export default FormikInput;
